import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/journal").then((r) => setPosts(r.data || []));
  }, []);

  return (
    <div data-testid="journal-page" className="bg-poche-black text-white">
      <section className="container-x py-20">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">The Joseph Poche Journal</p>
        <h1 className="font-serif text-6xl md:text-7xl mt-4 leading-[0.95]">Notes from the<br /><span className="italic text-poche-gold">house.</span></h1>
        <p className="text-white/65 mt-6 max-w-xl">Editorial. Sport. Travel. The longer view from inside the atelier.</p>
      </section>

      <section className="container-x pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {posts.map((p, i) => (
            <Link
              key={p.slug}
              to={`/journal/${p.slug}`}
              data-testid={`journal-${p.slug}`}
              className={`group block ${i === 0 ? "md:col-span-7" : "md:col-span-5"}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img src={p.image} alt={p.title} className="product-img absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
              </div>
              <div className="pt-6">
                <div className="flex items-center gap-4 text-[10px] tracking-luxury uppercase text-white/45">
                  <span className="text-poche-gold">{p.category}</span> · <span>{p.date}</span> · <span>{p.read_minutes} min read</span>
                </div>
                <h2 className="font-serif text-3xl md:text-4xl mt-3 group-hover:text-poche-gold transition-colors">{p.title}</h2>
                <p className="text-white/65 mt-3 max-w-lg">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-4 text-[11px] tracking-luxury uppercase text-poche-gold">Read story <ArrowRight size={14} /></span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
